function debounce(func, delay) {
    let timerId
    return function(...args) {
        if (timerId) {
            clearTimeout(timerId)
        }
        timerId = setTimeout(() => {
            func.apply(this, args)
            timerId = null
        }, delay)
    }
}

export default {
    methods: {
        debounce(func, delay) {
            return debounce(func, delay)
        }
    }
}
